{
  "en": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Add an assignee",
        "bulk_remove": "Remove",
        "confirm": "Mark as done",
        "delete": "Delete assignee",
        "document_add": "Add file",
        "document_delete": "Delete",
        "due_in_month": "In a month",
        "due_in_two_weeks": "In two weeks",
        "due_in_week": "In one week",
        "due_remove": "Remove deadline",
        "open": "Open",
        "reopen": "Reopen",
        "selectAll": "Select all {total}",
        "send_and_notify": "Send and notify",
        "set_due_date": "Set due date",
        "set_status": "Set status",
        "unSelectAll": "Deselect all",
        "upload_files": "Upload {count} file | Upload {count} files"
      },
      "assignee_scopes": {
        "external": "External",
        "internal": "Internal"
      },
      "assignee_types": {
        "customer": "Customer",
        "employee": "Team member",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Assignee",
        "assignees": "Assignees",
        "comment": "Comment",
        "created_at": "Created",
        "document": "Document",
        "due_date": "Due date",
        "project": "Project",
        "status": "Status",
        "task": "Task",
        "unit": "Unit"
      },
      "confirm": {
        "assignees_count": "{count} assignee | {count} assignees",
        "bulk_delete_accept": "Remove",
        "bulk_delete_body": "This removes their task for those units. The task itself and the other assignees keep theirs.",
        "bulk_delete_body_project": "This removes their task. The task itself and the other assignees keep theirs.",
        "bulk_delete_header": "Remove {count} assignee? | Remove {count} assignees?",
        "complete_accept": "Complete everything",
        "complete_body": "This sets {assignees} to {status}, including the tasks the customer has not completed themselves. They move to the completed tasks in their list.",
        "complete_header": "Mark everything as completed?",
        "customer_tasks": "{count} customer task | {count} customer tasks",
        "customers_and_team": "{customers} and {team}",
        "delete_body": "This removes their task for that unit. Other units and assignees keep theirs.",
        "delete_body_project": "This removes their task. Other assignees keep theirs.",
        "delete_header": "Remove {name} from {unit}?",
        "delete_header_project": "Remove {name} from this task?",
        "delete_sent_customers": "This one was already sent, so it disappears from the customers' portal as well.",
        "delete_sent_team": "This one was already sent, so it disappears from the list of {name} as well.",
        "document_delete_body": "The file leaves the unit's documents as well.",
        "document_delete_body_project": "The file leaves the project's documents as well.",
        "document_delete_header": "Delete this file?",
        "draft_accept": "Move everything to draft",
        "draft_body": "This sets {assignees} back to {status}. The task disappears from the customer's list until you send it again. Emails already sent stay sent.",
        "draft_header": "Move everything back to draft?",
        "send_body": "This sets {who} to {status}.",
        "send_customers": "Customers see the task in their portal straight away and get an email about it.",
        "send_header": "Send this task? | Send these tasks?",
        "send_permanent": "You can set them back to Draft later, but the notification has already gone out.",
        "send_team": "Team members see the task on their dashboard and are notified.",
        "tasks_count": "{count} task | {count} tasks",
        "team_tasks": "{count} team task | {count} team tasks"
      },
      "deep_link": {
        "completed": "This task is already completed.",
        "gone": "This task is no longer open."
      },
      "empty": {
        "filtered_description": "Adjust your filters, or clear them to see every assignment.",
        "filtered_title": "No assignments match your filters",
        "none_title": "No assignments"
      },
      "filters": {
        "assignee_any": "Any assignee",
        "clear_all": "Clear all filters",
        "done": "Done",
        "due_window_values": {
          "none": "No deadline",
          "overdue": "Overdue",
          "set": "Has a deadline"
        },
        "phase_any": "Any phase",
        "show_only": "Show only",
        "show_only_values": {
          "customers": "Customers",
          "mine": "Assigned to me",
          "team": "Team"
        },
        "unit_any": "Any unit"
      },
      "labels": {
        "add_assignee": "Add an assignee",
        "add_customers": "Add customers",
        "already_assigned": "This task is already added to this unit.",
        "already_assigned_project": "This task is already added to this project.",
        "assignees_subtitle": "Each one gets their own task, per unit.",
        "assignees_title": "Who needs to do it",
        "comment_earlier_round": "earlier round",
        "comment_placeholder": "e.g. the meter was hard to reach, this is the best photo I could get",
        "comments_none": "The customer left no comment.",
        "comments_title": "Comments on this task",
        "completed": "Completed",
        "completed_tasks": "Completed tasks",
        "confirm_message": "Are you sure you want to mark this task as done?",
        "customers": "Customers",
        "documents_none": "Nothing uploaded yet.",
        "documents_title": "Files on this task",
        "earlier": "+{count} earlier",
        "my_tasks": "My tasks",
        "no_assignees": "No assignees yet.",
        "no_assignments": "Tasks assigned to you show up here.",
        "no_assignments_task": "No assignments for this task yet.",
        "previous_upload": "earlier upload",
        "required": "This field is required",
        "selectOne": "Select at least one assignment.",
        "select_task": "Select a task",
        "selected": "{selected} selected | {selected} selected",
        "set_status_for": "Set status for {name}",
        "status_hint_assignees": "the assignee | the assignees",
        "status_hint_customer": "the customer",
        "status_hint_sent": "the assignees it was sent to",
        "superseded": "superseded",
        "totalSelected": "All {total} selected",
        "upload_hint": "Upload the requested document(s) to complete this task."
      },
      "status_hints": {
        "completed": "This task is completed. It stays visible to {who}, under {completed}.",
        "draft": "Not yet visible to {who}. Set the task to {open} to share it.",
        "requested": "Visible to {who}. The task still needs to be completed."
      },
      "statuses": {
        "completed": "Completed",
        "draft": "Draft",
        "requested": "Open"
      },
      "toasts": {
        "bulk_delete": "Assignments removed",
        "bulk_update": "Assignments updated",
        "completed": "Task completed",
        "create": "Task created",
        "delete": "Assignee deleted",
        "document_added": "File added",
        "document_deleted": "File deleted",
        "reopened": "Task reopened",
        "update": "Task updated"
      }
    }
  }
}
